import withMainLayout from 'layouts/main';
import Link from '@/links';
import dynamic from 'next/dynamic';
import {BreakVisibleInDesktop} from '@/breaks';

// Hero Component import
import InnerPartnerPagesHeroSection from '@/content/partnership-program/shared-components/hero-section';

// Dynamic Content Components import
const PartnerWithUs = dynamic(
  import('@/content/partnership-program/technology-partners/partner-with-us/index'),
  {
    loading: () => null
  }
);
const ExploreOptions = dynamic(
  import('@/content/partnership-program/technology-partners/explore-options/index'),
  {
    loading: () => null
  }
);
const IntegrationPartners = dynamic(
  import('@/content/partnership-program/technology-partners/integration-partners/index'),
  {
    loading: () => null
  }
);
const BuildingApi = dynamic(
  import('@/content/partnership-program/technology-partners/building-api/index'),
  {
    loading: () => null
  }
);
const JoinOurNetworkSection = dynamic(
  import('@/content/partnership-program/shared-components/join-our-network'),
  {
    loading: () => null
  }
);
const PreFooter = dynamic(() => import('@/prefooter'), {
  loading: () => null
});
const seoMetas = {
  title: 'Learn about our Technology Partnerships | Workable Technology Partner Program',
  description:
    'Learn more about how we collaborate with partners and build integrations on our API',
  canonical: 'https://www.workable.com/partnership-program/technology-partners',
  ogimage: 'https://www.workable.com/static/images/workable-partners-social-share.png'
};

const prefooterContent = {
  backgroundImg: 'prefooter-bg-partners.jpg',
  title: 'Explore Workable partnerships',
  subtitle:
    'Ready to grow your customer-base, tap into new networks and help your clients find and hire the best talent?'
};

const TechnologyPartnersPage = () => (
  <>
    <InnerPartnerPagesHeroSection
      title={
        <>
          Integrate with a <BreakVisibleInDesktop />
          powerful HR and applicant tracking system
        </>
      }
    />
    <PartnerWithUs />
    <ExploreOptions />
    <IntegrationPartners />
    <BuildingApi />
    <JoinOurNetworkSection variant="technology-partners" />
    <PreFooter {...prefooterContent}>
      <Link href="/partnership-program/apply" variant="primary-sm">
        Partner with us
      </Link>
    </PreFooter>
  </>
);

export default withMainLayout(TechnologyPartnersPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
